import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InvestorType } from "../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { hasRegularPayments } from "../../../../Shared/IST/Components/Shared/Utils";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../Actions/Action";
import { Contents } from "../../../Resoures/Contents";
import {
    AccountRoleStore,
    ClientAccountStore,
    ProductDetailsStore,
    TreasuredAssetsStore,
    UserStore,
} from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { DocumentsAndDeclarations } from "../Common/Documents/Components/DocumentsAndDeclarations";
import { ClientNameHelper } from "../Common/Helpers/ClientNameHelper";
import { SubAccountTypeHelper } from "../Common/Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../Common/Resource/Contents";
import { isJointOrTrustAccount } from "../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { SPTAction } from "../SinglePaymentTransferWizard/Actions/SPTActions";
import { RegularPaymentAction } from "./Actions/RegularPaymentActions";
import { AdviserCharges } from "./Components/AdviserCharges/AdviserCharges";
import { InvestmentSelectionTool } from "./Components/IST/IST";
import { PaymentsIn } from "./Components/PaymentsIn/PaymentsIn";
import { Review } from "./Components/Review/Review";
import { productMap, RegularPaymentSteppersMap, RegularPaymentActionType } from "./Resource/Contents";
import { ExistingRegularPaymentsStore, RegularPaymentInstructionStore } from "./Store/Variable";
import { QuoteErrors } from "../../../../../Wrap/Validation/Errors/Quote/QuoteErrors";
import { RegularPaymentResult } from "../../../../../Wrap/Models/Models/Payments/RegularPayment/RegularPaymentResult";

interface IRegularPaymentWizardState extends IAccountContextWizardComponentState {
    extraInfo: {
        hasCashIsa: boolean;
        treasuredAssetProductIds: number[];
        treasuredAssetsInstructionId: number;
    };
    isInstructionLoading: boolean;
    autoLineCompleted: boolean;
}

export class RegularPaymentWizard extends AccountContextWizardComponent<IRegularPaymentWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            onPosting: false,
            active: true,
            isLoading: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: {
                hasCashIsa: false,
                treasuredAssetProductIds: null,
                treasuredAssetsInstructionId: null,
            },
            isInstructionLoading: false,
            autoLineCompleted: true,
        };
    }
    constructor(props: any) {
        super(props);
        this.subscribeToStore(RegularPaymentInstructionStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(ExistingRegularPaymentsStore, () => this.onExitingRegularPaymentsStoreChange());
    }

    componentDidUpdate(prevProps) {
        const { clientAccount, customer, isInstructionLoading } = this.state;
        if (clientAccount && customer && !this.state.data && !isInstructionLoading) {
            const action = getQueryParameters()["action"];
            const hierarchyId = getQueryParameters()["hierarchyid"];
            const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);
            this.setState({ isInstructionLoading: true });
            RegularPaymentAction.getInstruction(
                id,
                type,
                hierarchyId,
                subAccountHierarchyId,
                this.state.customer?.CustomerId,
                action
            );
        }
    }

    onClientAccountStoreChange() {
        super.onClientAccountStoreChange();
        if (this.state.clientAccount) {
            const type = Number(getQueryParameters()["type"]);
            if (type === SubAccountType.StocksIsa) {
                const extraInfo = this.state.extraInfo;
                extraInfo.hasCashIsa = this.state.clientAccount.SubAccounts.some(
                    (ele) => ele.ProductDisplayName == "ISA Cash"
                );
                this.setState({ extraInfo: extraInfo });
            }
        }
    }

    private onInstructionStoreChange() {
        if (RegularPaymentInstructionStore.getActionType() == ActionType.Success) {
            const data = RegularPaymentInstructionStore.getData();
            this.setState({
                isLoading: false,
                data: data.Errors != null && data.Errors.length > 0 ? this.state.data : data,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
                isInstructionLoading: false,
            });
            const isEdit = getQueryParameters()["action"] === RegularPaymentActionType.Edit;
            isEdit && this.checkRegularPaymentAutoLine();
        } else if (RegularPaymentInstructionStore.getActionType() == ActionType.Update) {
            const extraInfo = this.state.extraInfo;
            extraInfo.hasCashIsa = RegularPaymentInstructionStore.getHasCashIsa();
            this.setState({
                extraInfo: extraInfo,
            });
        }
    }

    private onExitingRegularPaymentsStoreChange() {
        if (ExistingRegularPaymentsStore.getActionType() == ActionType.Success) {
            const isLoading = RegularPaymentInstructionStore.isLoading();
            if (!isLoading) {
                const updatedData = this.initialiseFromExistingRegularPayments();
                this.setState({
                    isLoading: false,
                    data: updatedData,
                });
            }
        }
    }

    private initialiseFromExistingRegularPayments() {
        const data = RegularPaymentInstructionStore.getData();
        const existing = ExistingRegularPaymentsStore.getData() || [];
        data.Contribution.ClientRegularPayment =
            existing.find((payment) => {
                return payment.Source === "Client";
            }) || null;
        data.Contribution.ThirdPartyRegularPayment =
            existing.find((payment) => {
                return payment.Source === "ThirdParty";
            }) || null;
        data.Contribution.EmployerRegularPayment =
            existing.find((payment) => {
                return payment.Source === "Employer";
            }) || null;
        return data;
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.getProductDetails(hierarchyId);
    }

    private getProductDetails(hierarchyId: string) {
        const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
        const wrapcash = ProductDetailsStore.getSubAccount(SubAccountType.WrapCash);

        if (!wrapcash) {
            Action.getProductsValuationDetailSummary(hierarchyId, null, _date);
        }
    }

    private checkRegularPaymentAutoLine() {
        const regularBuyId = this.state.data?.Contribution?.ClientRegularPayment?.RegularBuyId;

        if(!regularBuyId) {return false;}

        RegularPaymentAction.checkRegularPaymentAutolineCompleted(regularBuyId, (result) => {
            if (result?.Id === QuoteErrors.DirectDebitCanNotBeChangedBecauseLastAutoLineIsNotCompleted) {
                this.setState({
                    errorMsg: [result.Description],
                    isShowErrorMsg: true,
                });
                this.setState({ autoLineCompleted: false });
            }
        });
    }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            SPTAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                params["action"] === RegularPaymentActionType.Edit
                    ? ProcessType.EditRegularPayment
                    : ProcessType.AddRegularPayment
            );
        }
        const { customer } = this.state;

        RegularPaymentAction.saveInstruction(
            from,
            this.state.data,
            parseInt(params["type"]),
            customer?.CustomerId,
            (result) => {
                this.setState({ onPosting: false });
                if (result?.length > 0) {
                    this.setState({
                        errorMsg: result.map((x) => x.UserMessage),
                        isShowErrorMsg: true,
                    });
                } else {
                    if (this.state.extraInfo.treasuredAssetsInstructionId) {
                        Action.setInstructionTreasuredAssetsProductIds(
                            this.state.extraInfo.treasuredAssetsInstructionId,
                            this.state.extraInfo.treasuredAssetProductIds,
                            () => {
                                this.setState({ onPosting: false });
                                this.navigate(to, toUrl, params);
                            }
                        );
                    } else {
                        this.setState({ onPosting: false });
                        this.navigate(to, toUrl, params);
                    }
                }
            }
        );
    }

    private navigate(to, toUrl, params) {
        if (to == -1) {
            this.onExit();
        } else {
            Navigator.navigateTo(toUrl, {
                queryParamsObject: params,
                scrollAfterNavigating: true,
            });
        }
    }

    onCancel() {
        // RegularPaymentAction.deleteInstruction(this.state.data.HierarchyId, () => this.onExit());
        // SLP-70599
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        RegularPaymentAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => {
                this.setState({ isSubmitting: false });
                const params = getQueryParameters();
                const instructionId = HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId;
                SPTAction.cancelCommissionCharges(
                    instructionId,
                    params["hierarchyid"],
                    params["subaccounthierarchyid"],
                    this.state.data.Contribution.CancelAllCommissionCharges
                );
            }
        );
    }

    onTreasuredAssetsStoreChange() {
        const treasuredAssetProductIds = TreasuredAssetsStore.getTreasuredAssetsProductIds();
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: treasuredAssetProductIds,
                treasuredAssetsInstructionId: null,
            },
        });
    }

    onChangeTreasuredAssets(hierarchyId: string, productId: number, value: boolean) {
        let productIds = this.state.extraInfo.treasuredAssetProductIds;
        if (value) {
            productIds.push(productId);
        } else {
            productIds = productIds.filter((id) => id !== productId);
        }
        this.setState({
            extraInfo: {
                hasCashIsa: this.state.extraInfo.hasCashIsa,
                treasuredAssetProductIds: productIds,
                treasuredAssetsInstructionId: HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId,
            },
        });
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const len = this.stepperConfig.length;
        const { customer } = this.state;
        return [
            {
                title: RegularPaymentSteppersMap.review,
                url: Urls.get().RegularPaymentReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <Review {...this.getStepProps(len)} type={type} />,
            },
            {
                title: RegularPaymentSteppersMap.doc,
                url: Urls.get().RegularPaymentDoc,
                path: Contents.URLMap.documentAndDeclarations,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <DocumentsAndDeclarations
                        subAccountType={type}
                        {...this.getStepProps(len + 1)}
                        processType={processTypeEnum.RegularPayment}
                        clAccountId={this.state.clientAccount?.HeadClAccountId}
                        isJointOrTrust={isJointOrTrustAccount(this.state.clientAccount?.InvestorType)}
                        customerId={customer.CustomerId}
                    />
                ),
            },
            {
                title: RegularPaymentSteppersMap.comfirm,
                url: Urls.get().RegularPaymentConfirm,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've received your instruction to set up a regular payment`}
                        isLoading={this.state.isSubmitting}
                        accountNumberMessage={`(${this.state.clientAccount?.HeadClAccountId})`}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const isEdit = getQueryParameters()["action"] === RegularPaymentActionType.Edit;
        const { Contribution } = this.state.data;
        const { customer } = this.state;
        const { autoLineCompleted } = this.state;
        const steppers = [
            {
                title: RegularPaymentSteppersMap.paymentsIn,
                url: Urls.get().RegularPaymentsIn,
                path: Contents.URLMap.paymentIn,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <PaymentsIn
                        {...this.getStepProps(0)}
                        type={type}
                        hasCashIsa={this.state.extraInfo.hasCashIsa}
                        isEdit={isEdit}
                        customerId={customer?.CustomerId}
                        autoLineCompleted={autoLineCompleted}
                    />
                ),
            },
        ];
        if (!SubAccountTypeHelper.isCashAccount(type)) {
            steppers.push({
                title: RegularPaymentSteppersMap.adviserCharges,
                url: Urls.get().RegularPaymentAdviserCharge,
                path: Contents.URLMap.adviserCharges,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <AdviserCharges {...this.getStepProps(1)} type={type} />,
            });
            if (type !== SubAccountType.CashIsa && hasRegularPayments(Contribution)) {
                steppers.push({
                    title: RegularPaymentSteppersMap.investment,
                    url: Urls.get().RegularPaymentIst,
                    path: Contents.URLMap.ist,
                    onStepLeave: (from, to) => {
                        this.onStepperLeave(from, to);
                    },
                    component: (
                        <InvestmentSelectionTool
                            {...this.getStepProps(2)}
                            type={type}
                            treasuredAssetProductIds={this.state.extraInfo.treasuredAssetProductIds}
                            onTreasuredAssetsStoreChange={() => this.onTreasuredAssetsStoreChange()}
                            onChangeTreasuredAssets={(subAccountInstructionId, productId, value) => {
                                this.onChangeTreasuredAssets(subAccountInstructionId, productId, value);
                            }}
                        />
                    ),
                });
            }
        }
        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const { data } = this.state;
        const type = Number(getQueryParameters()["type"]);
        const processProps = super.setProcessProps();
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: ClientNameHelper.clientNameDisplay(data?.ClientDetails, data?.SecondClientDetails),
            splitHeaderSub: this.state.clientAccount?.HeadClAccountId,
        };
        processProps.processTitle =
            getQueryParameters()["action"] === RegularPaymentActionType.Edit
                ? "Edit regular payment instruction(s)"
                : "Add regular payment instruction(s)";
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
